import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/').pop() || 'all';

  return (
    <section className="py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-1 h-5 rounded-full bg-accent-500" />
          <h2 className="text-lg md:text-xl font-heading text-foreground-950">电影分类</h2>
        </div>
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer flex-shrink-0 ${
                currentSlug === cat.slug
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800 border border-background-200/60'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </span>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}